var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWeiteres(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Weiteres__Icn/40px/Weiteres",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Weiteres__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Weiteres__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20,17 C21.6568542,17 23,18.3431458 23,20 C23,21.6568542 21.6568542,23 20,23 C18.3431458,23 17,21.6568542 17,20 C17,18.3431458 18.3431458,17 20,17 Z M20,19 C19.4477153,19 19,19.4477153 19,20 C19,20.5522847 19.4477153,21 20,21 C20.5522847,21 21,20.5522847 21,20 C21,19.4477153 20.5522847,19 20,19 Z M28,17 C29.6568542,17 31,18.3431458 31,20 C31,21.6568542 29.6568542,23 28,23 C26.3431458,23 25,21.6568542 25,20 C25,18.3431458 26.3431458,17 28,17 Z M28,19 C27.4477153,19 27,19.4477153 27,20 C27,20.5522847 27.4477153,21 28,21 C28.5522847,21 29,20.5522847 29,20 C29,19.4477153 28.5522847,19 28,19 Z M12,17 C13.6568542,17 15,18.3431458 15,20 C15,21.6568542 13.6568542,23 12,23 C10.3431458,23 9,21.6568542 9,20 C9,18.3431458 10.3431458,17 12,17 Z M12,19 C11.4477153,19 11,19.4477153 11,20 C11,20.5522847 11.4477153,21 12,21 C12.5522847,21 13,20.5522847 13,20 C13,19.4477153 12.5522847,19 12,19 Z",
    id: ".._.._src_svg_Icn_40px_Weiteres__Combined-Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeiteres);
export default __webpack_public_path__ + "static/media/Weiteres.8d708c8f4ffaffe04427f8f16b9e0462.svg";
export { ForwardRef as ReactComponent };